import R from 'ramda'

const RECURRING_CONSENT_DISPLAY_TYPE = 'Received Recurring Consent'
const RECURRING_CONSENT_TRIGGER_TYPE = 'OPT_IN_RECURRING'

const isRecurringConsentWidgetTrigger = R.propEq(
  'type',
  RECURRING_CONSENT_TRIGGER_TYPE
)

const convertRecurringConsentWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(RECURRING_CONSENT_DISPLAY_TYPE)
})

export {
  isRecurringConsentWidgetTrigger,
  convertRecurringConsentWidgetTriggerToFormTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/widget-to-form/received-recurring-consent.js